import { DEFAULT_GRID_ID } from "@/consts/consts";

/**
 * @typedef {Object} SecurOSView
 * @property {string} cameras Cameras ids: cam1id,cam2id,cam3id,..,
 * @property {string} geometry View geometry: 0:0:1:1|1:0:1:1|...|2:1:1:1
 * @property {string} id View id: 1
 * @property {string} name View name: View 1
 */

/**
 * @class GlobalView
 * @property {string[]} cams Cameras ids: [cam1id,cam2id,cam3id,...]
 * @property {string} geometry View geometry: 0:0:1:1|1:0:1:1|...|2:1:1:1
 * @property {string} id View id: 1
 * @property {string} name View name: View 1
 * @property {boolean} isGlobalView Is global view flag
 * @property {number} grid Default grid id for GlobalViews
 */
export class GlobalView {
  /**
   * @param {SecurOSView} view
   */
  constructor(view) {
    this.cams = view.cameras.split(",");
    this.geometry = view.geometry;
    this.id = view.id;
    this.name = view.name;
    this.isGlobalView = true;

    this.grid = DEFAULT_GRID_ID;
  }
}



// WEBPACK FOOTER //
// ./src/classes/views/globalView.js